// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bEqOjCI8XsvmjJMEvpYU{margin-left:14px}.en0CF8FoeUiHYgbn9AT0{flex-grow:1;margin-left:16px;display:flex;position:relative}.fwZA3fUIA_c2mAZ5QR7b{margin-right:4px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"search": `bEqOjCI8XsvmjJMEvpYU`,
	"wrapTable": `en0CF8FoeUiHYgbn9AT0`,
	"inboxCellContainer": `fwZA3fUIA_c2mAZ5QR7b`
};
export default ___CSS_LOADER_EXPORT___;
